import type { PackageId } from './types';

/** Same defaults as [functions/src/config.ts](../../functions/src/config.ts) — Grow per tier. */
const DEFAULT_GROW_CHECKOUT: Record<PackageId, string> = {
  basic: 'https://pay.grow.link/949681ac40950e0f3059d3b6f35a65b9-MzM2MjQ4MA',
  plus: 'https://pay.grow.link/d502eef0e1eeb3e0d077cac9730eaf50-MzM2MjQ4MQ',
  family: 'https://pay.grow.link/76b7de46f1c1bc33e163ad1c7b2052d9-MzM2MjQ4Mg',
};

/**
 * Grow hosted checkout for the selected package. Env overrides (Vercel / local)
 * take precedence; otherwise repo defaults (must stay aligned with Functions).
 */
export function resolveClientGrowCheckoutUrl(pkg: PackageId): string {
  const envKey = `VITE_GROW_CHECKOUT_URL_${pkg.toUpperCase()}`;
  const fromEnv = (import.meta.env as Record<string, string | undefined>)[envKey]?.trim();
  if (fromEnv) return fromEnv;
  return DEFAULT_GROW_CHECKOUT[pkg] ?? '';
}

/** Query names echoed by Grow Payment Links webhooks (see functions `meshulamWebhook`). */
export const GROW_CHECKOUT_JOB_ID_PARAM = 'jobId';
export const GROW_CHECKOUT_MOMENTS_PROC_PARAM = 'momentsProc';

/**
 * Append Firestore job id and the pending checkout token (`proc_…` from
 * `meshulamCreateCheckout`) so the Grow webhook can correlate payment → job.
 */
export function appendGrowCheckoutCorrelationParams(
  growCheckoutUrl: string,
  jobId: string,
  momentsProcessId: string,
): string {
  const trimmed = growCheckoutUrl.trim();
  if (!trimmed) return trimmed;
  try {
    const u = new URL(trimmed);
    u.searchParams.set(GROW_CHECKOUT_JOB_ID_PARAM, jobId);
    u.searchParams.set(GROW_CHECKOUT_MOMENTS_PROC_PARAM, momentsProcessId);
    return u.toString();
  } catch {
    const sep = trimmed.includes('?') ? '&' : '?';
    return (
      `${trimmed}${sep}` +
      `${GROW_CHECKOUT_JOB_ID_PARAM}=${encodeURIComponent(jobId)}&` +
      `${GROW_CHECKOUT_MOMENTS_PROC_PARAM}=${encodeURIComponent(momentsProcessId)}`
    );
  }
}

/** Number of movie credits included in each paid package (only this differs by tier). */
export const PACKAGE_MOVIE_COUNT: Record<PackageId, number> = {
  basic: 1,
  plus: 3,
  family: 10,
};

/** ILS totals — keep in sync with [functions/src/types.ts](../../functions/src/types.ts). */
export const PACKAGE_PRICES: Record<PackageId, number> = {
  basic: 49,
  plus: 119,
  family: 349,
};

export const PACKAGE_ORDER: PackageId[] = ['basic', 'plus', 'family'];

export function movieCountHebrew(n: number): string {
  if (n === 1) return 'סרטון 1';
  return `${n} סרטונים`;
}
